import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * These are simply names set to a map for various configurations
 */
var ConfigurationEnum;
(function (ConfigurationEnum) {
    // Set a value for the Saved Search endpoint here.  If this value isn't null, the saved search functionality will be used.
    ConfigurationEnum[ConfigurationEnum["GRID_SAVED_SEARCH_ENDPOINT"] = 0] = "GRID_SAVED_SEARCH_ENDPOINT";
    ConfigurationEnum[ConfigurationEnum["GATEWAY_CONTEXT_PATH"] = 1] = "GATEWAY_CONTEXT_PATH";
    ConfigurationEnum[ConfigurationEnum["USER_PROFILE_CONTROLLER_ENDPOINT"] = 2] = "USER_PROFILE_CONTROLLER_ENDPOINT";
    //Primary key for records. Default value: id
    ConfigurationEnum[ConfigurationEnum["PRIMARY_KEY_PARAMETER_DEFAULT"] = 3] = "PRIMARY_KEY_PARAMETER_DEFAULT";
    // Changes the CSS color for edited rows on grids
    ConfigurationEnum[ConfigurationEnum["EDITED_ROW_CSS_CLASS"] = 4] = "EDITED_ROW_CSS_CLASS";
    // Boolean: True or False, does this application use PUT and DELETE (True) or just GETS and POSTS (False)
    ConfigurationEnum[ConfigurationEnum["HTTP_ADVANCED_METHODS"] = 5] = "HTTP_ADVANCED_METHODS";
    // Override the default GET suffix on the URL to be anything other than /get/
    ConfigurationEnum[ConfigurationEnum["HTTP_GET_API_SUFFIX"] = 6] = "HTTP_GET_API_SUFFIX";
    // Override the default CREATE suffix on the URL to be anything other than /create/
    ConfigurationEnum[ConfigurationEnum["HTTP_CREATE_API_SUFFIX"] = 7] = "HTTP_CREATE_API_SUFFIX";
    // Override the default UPDATE suffix on the URL to be anything other than /update/
    ConfigurationEnum[ConfigurationEnum["HTTP_UPDATE_API_SUFFIX"] = 8] = "HTTP_UPDATE_API_SUFFIX";
    // Override the default DELETE suffix on the URL to be anything other than /delete/
    ConfigurationEnum[ConfigurationEnum["HTTP_DELETE_API_SUFFIX"] = 9] = "HTTP_DELETE_API_SUFFIX";
    // Override the default LIST suffix on the URL to be anything other than /list/
    ConfigurationEnum[ConfigurationEnum["HTTP_LIST_API_SUFFIX"] = 10] = "HTTP_LIST_API_SUFFIX";
    // Override the default SEARCH suffix on the URL to be anything other than /search/
    ConfigurationEnum[ConfigurationEnum["HTTP_SEARCH_API_SUFFIX"] = 11] = "HTTP_SEARCH_API_SUFFIX";
    // Override the default response variable to be something other than "resultList"
    ConfigurationEnum[ConfigurationEnum["RESULT_LIST_VARIABLE_NAME"] = 12] = "RESULT_LIST_VARIABLE_NAME";
    // override the token name
    ConfigurationEnum[ConfigurationEnum["TOKEN_NAME"] = 13] = "TOKEN_NAME";
    /**
     * The endpoint for the API Gateway : Required
     */
    ConfigurationEnum[ConfigurationEnum["API_GATEWAY_URL"] = 14] = "API_GATEWAY_URL";
})(ConfigurationEnum || (ConfigurationEnum = {}));

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * This Injector is used in conjunction with the Configuration ENUM to set variables throughout the Shared Module.
 * Those variables should be set on the Application Loading Mechanism using the setValue.
 */
class ConfigurationInjector {
    constructor() {
        this.configurationMap = new Map();
    }
    getValue(property) {
        return this.configurationMap.get(property.toString());
    }
    setValue(property, value) {
        this.configurationMap.set(property.toString(), value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfigurationInjector, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfigurationInjector, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ConfigurationInjector, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigurationEnum, ConfigurationInjector };
